// Build-identity stamp (ZEN-84). The value is baked in at compile time from
// REACT_APP_BUILD_COMMIT (written by scripts/stamp-build.js before the build),
// so the commit a browser is actually RUNNING is readable from the loaded
// page — a stale cached bundle served next to a fresh build.json cannot
// impersonate a new release. Consumed by the production canary's journey.
export const BUILD_COMMIT = process.env.REACT_APP_BUILD_COMMIT || "unknown";

if (typeof window !== "undefined") {
  window.__ZEN_BUILD_COMMIT = BUILD_COMMIT;
}
